-<template>
  <b-form @submit.prevent="onSubmitModal">
    <div class="position-relative">
      <div class="modal-wrp mx-1">
        <b-row>
          <b-col cols="12" class="px-2 mb-1">
            <div class="d-flex">
              <div class="mr-auto">
                <div
                >
                  <label class="font-medium-5"
                    ><span class="text-black">Select Inventory</span>
                    (ทำการเพิ่มของรางวัลได้ทีละหนึ่งคลัง)</label
                  >
                  <v-select
                    v-model="formStatus.inventoryLabel"
                    class="v-select-inventory bg-dropdown"
                    :class="
                      formStatus.inventoryLabel
                        ? 'v-select-filter-selected'
                        : null
                    "
                    :clearable="false"
                    placeholder="- Select Inventory -"
                    :options="optionData.inventoryList"
                    @input="(option) => onSelectInventory(option.value)"
                  />
                </div>
              </div>
              <div class="mt-auto">
                <v-select
                  v-model="formStatus.status"
                  class="v-select-filter bg-dropdown"
                  :class="formStatus.status ? 'v-select-filter-selected' : null"
                  placeholder="Status"
                  :options="statusOption"
                  @input="(option) => onSelectFilter('status', option)"
                />
              </div>
              <div class="mt-auto">
                <div class="search-container mb-1 mb-md-0 mr-0 ml-0 ml-1">
                  <search :on-search-input="onSetValueSearch" />
                </div>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row v-if="formStatus.inventoryId != null" class="mt-2">
          <b-col cols="12" class="mb-1">
            <overlay-loading :loading="loading.tableData">
              <template #content>
                <b-table
                  id="inventory-table"
                  :fields="fields"
                  :items="inventoryTable.payload"
                  responsive
                  bordered
                  borderless
                  sticky-header
                  show-empty
                  class="default-static-table"
                  thead-tr-class="inventory-th-class text-left"
                >
                  <template #head(checkbox)>
                    <div>
                      <b-form-checkbox
                        v-model="inventorySelect.isSelectAllItem"
                        class="mapping-checkbox"
                        @change="onSelectAllInventoryItem"
                      >
                      </b-form-checkbox>
                    </div>
                  </template>
                  <template #cell(checkbox)="data">
                    <div>
                      <b-form-checkbox
                        v-model="data.item.isSelected"
                        class="mapping-checkbox"
                        :disabled="data.item.fdc_status != null"
                      />
                    </div>
                  </template>
                  <template #cell(seq)="data">
                    <div>{{ data.item.seq }}</div>
                  </template>
                  <template #cell(pv_image_url)="data">
                    <div>
                      <img class="img-col-add-privilege" :src="data.value || DefaultImg" />
                    </div>
                  </template>
                  <template #cell(pv_name_th)="data">
                    <div>{{ data.value }}</div>
                  </template>
                  <!-- <template #cell(privilege_type)="data">
                    <div>{{ data.item.privilege_type }}</div>
                  </template> -->
                  <template #cell(pv_valid_from)="data">
                    <div>
                      {{
                        data.value ? resolveDateWithSeperator(data.value) : "-"
                      }}
                    </div>
                  </template>
                  <template #cell(pv_valid_through)="data">
                    <div>
                      {{
                        data.value ? resolveDateWithSeperator(data.value) : "-"
                      }}
                    </div>
                  </template>
                  <template #cell(pv_status)="data">
                    <div class="d-flex align-items-center">
                      <feather-icon
                        icon="CircleIcon"
                        class="mr-2"
                        :class="resolveStatusClass(data.value)"
                      />

                      <span>{{ resolveStatusLabel(data.value) }}</span>
                    </div>
                  </template>
                  <template #cell(action)="data">
                    <cancel-button v-if="data.item.fdc_status != null" :btnLabel="'Cancel'" @click.native="removeEntry(data.item)" />
                  </template>
                  <template #empty>
                    <card-no-item :text-no-img="'Inventory Not Found'" />
                  </template>
                </b-table>
              </template>
            </overlay-loading>
          </b-col>
          <b-col v-if="inventoryTable.payload.length > 0" cols="12">
            <pagination-with-reorder
              entity-editable
              :pagination="pagination"
              @entityChange="onFilterEntity"
              @pageChange="onPageChange"
            />
          </b-col>
        </b-row>

        <empty-content
          v-else
          :image="require('@/assets/images/artwork/folder.png')"
          :width-img="'300px'"
          :height-img="'auto'"
          :title="'Select Inventory'"
          class="empty-content-history-custom-height"
        />
      </div>

      <div class="row">
        <div class="col-12">
          <div class="modal-btn-wrp mt-2 mb-2">
            <div class="d-flex justify-content-center">
              <cancel-button
                class="mr-1"
                @click.native="$emit('onCloseModal')"
              />
              <save-button
                :btn-label="'Next'"
                class="ml-1"
                type="submit"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-form>
</template>

<script>
import Search from "@/views/components/search/Search.vue";
import vSelect from "vue-select";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import EmptyContent from "@/views/components/empty-content/EmptyContent.vue";
import useDate from "@/utils/hooks/useDate";
import useAddPrivilege from "../hooks/useAddPrivilege";
import CancelButton from '@/views/components/button/CancelButton.vue';
import DefaultImg from "@/assets/images/icons/no-img-square.jpg";

export default {
  components: {
    vSelect,
    Search,
    CardNoItem,
    PaginationWithReorder,
    EmptyContent,
    CancelButton,
  },
  props: { privilegeObj: [Object, Array] },
  setup(props) {
    const {
      loading,
      formStatus,
      statusOption,
      optionData,
      pagination,
      fields,
      inventoryTable,
      inventorySelect,
      resolveNext,
      resolveStatusLabel,
      resolveStatusClass,
      onPageChange,
      onFilterEntity,
      onSetValueSearch,
      onSelectFilter,
      onSubmitModal,
      onSelectAllInventoryItem,
      onSelectInventory,
      removeEntry
    } = useAddPrivilege(props);

    const { resolveDateWithSeperator } = useDate();

    return {
      DefaultImg,
      loading,
      formStatus,
      statusOption,
      optionData,
      pagination,
      fields,
      inventoryTable,
      inventorySelect,
      resolveNext,
      resolveStatusLabel,
      resolveStatusClass,
      onPageChange,
      onFilterEntity,
      onSetValueSearch,
      onSelectFilter,
      onSubmitModal,
      onSelectAllInventoryItem,
      onSelectInventory,
      resolveDateWithSeperator,
      removeEntry
    };
  },
};
</script>

<style scope>
.mapping-checkbox
  .custom-control-input:checked
  ~ .custom-control-label::before {
  border-color: var(--primary) !important;
  background-color: var(--primary) !important;
  box-shadow: none !important;
}

.mapping-checkbox .custom-control-input:active {
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
}

.mapping-checkbox .custom-control-label::before,
.mapping-checkbox .custom-control-label::after {
  background-color: transparent !important;
  border-color: var(--primary) !important;
}

.mapping-checkbox
  .custom-control-input[disabled]
  ~ .custom-control-label::before,
.custom-control-input:disabled ~ .custom-control-label::before {
  background-color: #f5f5f5 !important;
}
</style>
